export default __webpack_public_path__ + "media/images/fonts/materialdesignicons-webfont-527080c4652828659a7b92516393c016.svg";